<template>
  <Authenticated>
    <div class="actions">
      <h2>Upcoming Orders</h2>
    </div>

    <div class="orders">
      <div class="filter-nav">
        <h2 v-if="view">Product View</h2>
        <h2 v-else>Customer View</h2>
        <div class="filter-options">
          <button @click="view = !view" class="action-colour">Customer/Products</button>
        </div>
      </div>
      <ul class="btn-layout">
        <li @click="changeWeek('previous')"><font-awesome-icon icon="fa-arrow-left"></font-awesome-icon></li>
        <template v-for="(date, idx) in week" :key="date + idx">
          <li @click="setDay(date)" :style="{ backgroundColor: this.orderDate === date ? 'var(--action-colour)' : '' }" class="day" :id="date">
            <font-awesome-icon
              icon="fa-calendar-days"
              class="today"
              v-if="
                date === `${today.getFullYear()}-${(today.getMonth() + 1 < 10 ? '0' : '') + (today.getMonth() + 1)}-${(today.getDate() < 10 ? '0' : '') + today.getDate()}`
              "></font-awesome-icon>
            {{ date }}
          </li></template
        >
        <li @click="changeWeek('next')"><font-awesome-icon icon="fa-arrow-right"></font-awesome-icon></li>
      </ul>
      <ul class="btn-layout">
        <li
          v-for="(site, idx) in $store.getters.siteSettings.pickupSites"
          :key="idx + site"
          :style="{ backgroundColor: this.location === site ? 'var(--action-colour)' : '' }"
          @click="this.location = site">
          {{ site }}
        </li>
      </ul>
      <input class="date-picker" type="date" v-model="orderDate" @change="handleDate" />
      <!-- <Datepicker class="date-picker" is-range v-model="this.orderDate" @update:model-value="handleDate" :format="format" :enableTimePicker="false" auto-apply></Datepicker> -->
      <template v-if="orders.length > 0">
        <table class="order-table-products" v-if="view">
          <thead>
            <tr>
              <th>Name</th>
              <th>Category</th>
              <th>Modifier</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in orderTotals" v-bind:key="order">
              <td>{{ order.name }}</td>
              <td>{{ order.category }}</td>
              <td>{{ order.modifier }}</td>
              <td>{{ order.quantity }}</td>
            </tr>
          </tbody>
        </table>
        <ul class="order-table-customer" v-else>
          <li v-for="order in this.orders" v-bind:key="order">
            <p>{{ order.value.name }}</p>
            <p>{{ order.value.cell }}</p>
            <p>{{ order.value.notes }}</p>
            <button class="print-btn action-colour" @click.stop.prevent="printOrder(order)">Print Order</button>
            <button class="print-btn action-colour" @click.stop.prevent="recallOrder(order)">Edit Order</button>
            <table class="customer-products-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Quantity</th>
                  <th>Modifiers</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="prod in order.value.products" v-bind:key="prod">
                  <td>{{ prod.name }}</td>
                  <td>{{ prod.quantity }}</td>
                  <td>
                    <p v-for="mod in prod.modifier_list" v-bind:key="mod">{{ mod.name }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </li>
        </ul></template
      >
      <h2 v-else>No Orders Found on this date at this location</h2>
      <div class="hide">
        <canvas id="printCanvas"></canvas>
        <!-- {{ imgsrc }} -->
      </div>
    </div>
  </Authenticated>
</template>

<script>
/** DATE IS EXPECTED AS YYYY/MM/DD */
import Authenticated from "@/components/_layouts/Authenticated";
import { api } from "@monolith/helpers";

export default {
  components: { Authenticated },
  mixin: [],
  data() {
    return {
      orders: [],
      orderDate: null,
      view: true,
      location: "city",
      week: null,
      today: null,
      imgsrc: null,
      monthsOrders: null,
    };
  },
  async created() {
    this.orderDate = this.formatDate(new Date());
    this.today = new Date();
  },
  setup() {
    const format = (orderDate) => {
      return `Selected date is ${orderDate.toISOString().slice(0, 10)}`;
    };
    return {
      format,
    };
  },
  methods: {
    recallOrder(order) {
      this.$store.dispatch("initialiseCartFromHistory", order.value);
      this.$router.push("/");
    },
    printOrder(order) {
      let cut = true;
      let printCanvas = document.getElementById("printCanvas");
      let img = new Image();

      printCanvas.height = this.getHeight(order.value.products);
      printCanvas.width = "3000";
      let ctx = printCanvas.getContext("2d");
      img.onload = () => {
        ctx.drawImage(img, 250, 100, 2500, 800);
        let printer = JSON.parse(localStorage.getItem("printer"));
        let dataURL = printCanvas.toDataURL();
        if (window.android) {
          window.Android.printItem(dataURL, printer["ip"], printer["model"], printer["label"], cut);
        } else if (window.webkit && window.webkit.messageHandlers) {
          window.webkit.messageHandlers.brotherHandler.postMessage({
            action: "printItem",
            additionalData: {
              dataURL: dataURL,
              ip: printer["ip"],
              model: printer["model"],
              label: printer["label"],
              cut: cut,
            },
          });
        }
      };
      ctx.font = "300px sans-serif";
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, printCanvas.width, printCanvas.height);
      img.src =
        "data:image/png;base64,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";

      // img.src = "https://beammeup.nz/bmu_favicon.png";
      //ctx.drawImage(img, 80, 10, 140, 140);
      ctx.fillStyle = "#000";
      ctx.fillText(order.value.name, 100, 1250);
      ctx.font = "200px sans-serif";

      ctx.fillText(order.value.pickup_date, 100, 1500);
      ctx.fillText(order.value.cell, 100, 1750);
      let products = order.value.products;
      let currentY = 1850;
      products.forEach((product) => {
        currentY += 250;
        ctx.fillText(product.quantity + " x " + product.name, 100, currentY);
        product.modifier_list.forEach((mod) => {
          currentY += 250;
          ctx.fillText("-" + mod.name, 200, currentY);
        });
        currentY += 250;
      });

      currentY += 250;
      ctx.fillText("Thanks for your order!", 100, currentY);
    },

    getHeight(prods) {
      let height = prods.length;
      prods.map((p) => (height += p.modifier_list.length));
      return height * 400 + 2200;
    },

    handleDate() {
      this.orderDate = this.formatDate(this.orderDate);
      if (!this.week.includes(this.orderDate)) {
        this.week = this.getWeekDates(this.orderDate);
      }
      this.apiCall();
    },
    formatDate(date) {
      // Guard against timezone issues (e.g. "daylight time" sending it one day back)
      if (typeof date === "string") {
        date = new Date(date);
      }
      // Get local year, month, day
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const formatted = `${year}-${month}-${day}`;
      return formatted;
    },
    changeWeek(direction) {
      if (!this.week) {
        this.week = this.dateWeek;
      }
      this.week = this.week.map((date) => {
        let newDate = new Date(date);
        newDate.setDate(direction == "next" ? newDate.getDate() + 7 : newDate.getDate() - 7);
        return this.formatDate(newDate);
      });
    },
    getWeekDates(inputDate) {
      const date = new Date(inputDate);
      const day = date.getDay();
      const diff = date.getDate() - day + (day == 0 ? -6 : 1); // Adjust for Sunday
      const monday = new Date(date.setDate(diff));

      const weekDates = [];
      for (let i = 0; i < 7; i++) {
        const currentDate = new Date(monday);
        currentDate.setDate(monday.getDate() + i);
        weekDates.push(currentDate.toISOString().slice(0, 10));
      }

      return weekDates;
    },

    //sets the selected date to the date clicked on
    // and highlights the date
    setDay(date) {
      document.querySelectorAll(".day").forEach((element) => {
        element.style.removeProperty("background-color");
      });
      document.getElementById(date).style.backgroundColor = "var(--action-colour)";
      this.orderDate = date;
      this.apiCall();
    },
    locationSelect() {
      this.apiCall();
    },
    async apiCall(od = this.orderDate) {
      const companyString = localStorage.getItem("company");
      const siteString = window.localStorage.getItem("site");
      let allOrders = await api.post("/api/get_future_orders/" + siteString, { key: '["' + od + '",' + '"' + this.location + '"]' });
      this.orders = allOrders.rows;
    },
    async getOrders(od = this.orderDate) {
      const companyString = localStorage.getItem("company");
      const siteString = window.localStorage.getItem("site");
      let allOrders = await api.post("/api/get_future_orders/" + siteString, { key: '["' + od + '",' + '"' + this.location + '"]' });
      return allOrders.rows;
    },

    async getMonthsOrders(year, month) {
      // month needs to be yyyy-mm
      const companyString = localStorage.getItem("company");
      const siteString = window.localStorage.getItem("site");
      let date = year + "-" + month;
      let monthsOrders = await api.post("/api/get_months_order/" + siteString, { keys: '["' + date + '"]' });
      this.monthsOrders = monthsOrders.rows;
    },
  },
  computed: {
    dateWeek() {
      let dateArray = [];
      let date = new Date(this.today);
      let day = date.getDay();
      let diff = date.getDate() - day + (day == 0 ? -6 : 1);
      let monday = new Date(date.setDate(diff));
      for (let i = 0; i < 7; i++) {
        dateArray.push(monday.toISOString().slice(0, 10));
        monday.setDate(monday.getDate() + 1);
      }

      return dateArray;
    },
    orderDates() {
      return this.monthsOrders.map((order) => {
        return order.value.pickup_date;
      });
    },
    orderTotals() {
      let productHash = {};

      this.orders.forEach((order) => {
        order.value.products.forEach((element) => {
          if (productHash[element.category + element.hash]) {
            let newQuantity = productHash[element.category + element.hash].quantity + element.quantity;
            productHash[element.category + element.hash].quantity = newQuantity;
          } else {
            let modString = "";
            if ("modifier_list" in element && element["modifier_list"].length !== 0) {
              element.modifier_list.forEach((mod) => {
                modString.length > 0 ? (modString += " - " + mod.name) : (modString += mod.name);
              });
            }

            productHash[element.category + element.hash] = { category: element.category, quantity: element.quantity, name: element.name, modifier: modString };
          }
        });
      });
      const sorted = Object.keys(productHash)
        .sort()
        .reduce((accumulator, key) => {
          accumulator[key] = productHash[key];

          return accumulator;
        }, {});

      return sorted;
    },
  },
  mounted() {
    this.$store.commit("currPage", "orders");

    //set new variable as dateweek is readonly
    this.week = this.dateWeek;
    //highlights todays date on inital load
    this.apiCall();
  },
  watch: {
    location() {
      this.apiCall();
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";
// @import 'v-calendar/lib/v-calendar.min.css';

.hide {
  display: none;
}

.orders {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 1rem;

  .filter-nav {
    display: flex;
    justify-content: space-between;
    width: 95%;
  }

  .filter-options {
    display: flex;
    flex-direction: row-reverse;
    gap: 5px;
    align-items: center;

    button {
      margin-right: 0rem;
    }
    select {
      width: 5rem;
      height: 3rem;
    }
  }

  .print-btn {
    float: right;
    width: 100%;
    margin: 0.5rem 0;
  }

  .btn-layout {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    li {
      float: left;
      display: block;
      color: var(--text-colour);
      text-align: center;
      padding: 8px;
      text-decoration: none;
      border: 1px solid var(--action-colour);
      margin: 0.5rem;
      position: relative;
      border-radius: 0.5rem;
      cursor: pointer;
      text-transform: uppercase;
      &:hover {
        background-color: var(--secondary-colour);
      }
    }
    .today {
      position: absolute;
      top: -0.5rem;
      right: -0.5rem;
      color: var(--action-colour);
      background-color: var(--primary-colour);
      border: 2px solid var(--primary-colour);
      border-radius: 0.25rem;
    }
  }

  .date-picker {
    width: 95%;
  }

  .order-table-products {
    font-family: arial, sans-serif;
    border-collapse: seperate;
    border-spacing: 0;
    width: 95%;
    margin-bottom: 2rem;
    border-radius: 0.25rem;
    border: 1px solid #dddddd;
    td,
    th {
      border-bottom: 1px solid #dddddd;
      text-align: left;
      padding: 8px;
    }
    tr:nth-child(even) {
      background-color: var(--secondary-colour);
    }
  }
  .order-table-customer {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 95%;
    padding-inline-start: 0px;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    background-color: var(--secondary-colour);
    border-radius: 0.25rem;
    td,
    th {
      border: 0px solid #dddddd;
      text-align: left;
      padding: 8px;
    }

    li {
      margin: 1rem;
      max-width: 22rem;
      // box-shadow: 2px 2px 2px var(--action-colour);
      border: 1px solid #dddddd;
      border-radius: 0.25rem;
      padding: 0.5rem;
      background-color: var(--primary-colour);
      p {
        word-wrap: break-all;
      }
      table {
        max-width: 22rem;
        border: 1px solid var(--action-colour);
        border-spacing: 0;
        border-collapse: separate;
        border-radius: 0.25rem;
        td:nth-child(2) {
          text-align: center;
        }
      }
    }
  }
}
@media only screen and (orientation: portrait) {
  .orders {
    margin-top: 0;
    .filter-nav {
      max-width: 100%;
      width: 100%;
      h2 {
        min-width: 2rem;
      }
    }

    .date-picker {
      width: 100%;
    }
    .order-table-customer {
      width: 100%;
    }
    .order-table-products {
      width: 100%;
    }
  }
}
</style>
